import React, { useEffect, useState, forwardRef } from 'react';
import { cn } from '@/utils/cn';
import { useDispatch } from 'react-redux';
import {
  validatePass,
  validationResult,
} from '@/redux/reducers/help-request-reducer';
import Icon from '../Icon';
import TextSpan from '../Typography/TextSpan';

const TextInput = forwardRef(
  (
    {
      label = '',
      iconName,
      value = '',
      className,
      name,
      type = 'text',
      placeholder = 'Enter your value',
      onChangeHandler,
      maxLength = 50,
      isRequired = false,
      isReadOnly = false,
      validate = false,
      validationMessage = '',
      validationField = '',
    },
    ref,
  ) => {
    const dispatch = useDispatch();
    const [inputValue, setInputValue] = useState(value);
    const [error, setError] = useState('');
    // const [error, setError] = useState("Invalid text! Please Try Again.");

    useEffect(() => {
      if (validate) {
        if (!isRequired) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const orderIdRegex = /^\d{6}[A-Z]{2}\d{1}[A-Z]{1}$/;
          if (inputValue?.length > 0) {
            if (
              !orderIdRegex.test(inputValue) &&
              validationField === 'order_id_field'
            ) {
              setError(validationMessage);
              dispatch(validationResult({ invalid: true, name }));
              return;
            }
            if (
              !emailRegex.test(inputValue) &&
              validationField === 'email_field'
            ) {
              setError(validationMessage);
              dispatch(validationResult({ invalid: true, name }));
              return;
            }
          }
        } else if (inputValue.length <= 0) {
          setError(validationMessage);
          dispatch(validationResult({ invalid: true, name }));
          return;
        }
        setError('');
        dispatch(validatePass({ name }));
      }
    }, [validate]);

    const handleInput = (e) => {
      setInputValue(e.target.value);
      onChangeHandler(e);
    };

    useEffect(() => {
      setInputValue(value);
    }, [value]);

    return (
      <div className={cn('input-with-label relative w-full', className)}>
        <div
          className={cn(
            'flex flex-row items-center h-14 justify-center pl-12 border border-senate rounded-[4px] overflow-hidden font-encode-sans gap-3 focus-within:border-2 active:border-2',
            {
              '!border-infrared-burn': error,
              '!border-atelier': isReadOnly,
            },
          )}
        >
          {iconName ? (
            <Icon type={iconName} height="24px" width="24px" color="#5F6368" />
          ) : null}
          <input
            ref={ref}
            type={type}
            name={name}
            className={cn(
              'text-gray-dark block w-full px-0 py-16 text-base text-coarse-wool focus:outline-none focus:ring-0 placeholder:text-senate font-encode-sans placeholder:text-base placeholder:font-encode-sans placeholder:font-normal font-medium',
              {
                '!text-atelier placeholder:!text-atelier': isReadOnly,
              },
            )}
            maxLength={maxLength}
            placeholder={placeholder}
            onChange={handleInput}
            value={inputValue}
            readOnly={isReadOnly}
            // min={type === 'number' ? 1 : undefined}
            // onInput={(e) => {
            //   if (type === 'number' && e.target.value < 0) {
            //     e.target.value = 1;
            //   }
            // }}
          />
        </div>
        <label
          className={cn(
            'absolute top-[17px] font-encode-sans left-3 text-sm font-medium text-senate leading-16 tracking-[0.24px] bg-white transform -translate-y-6 px-[6px]',
            {
              '!text-infrared-burn': error,
              '!text-atelier': isReadOnly,
            },
          )}
        >
          {label}
          {isRequired ? (
            <TextSpan
              text="*"
              className="text-sm lg:text-sm text-infrared-burn"
            />
          ) : null}
        </label>
        {error ? (
          <TextSpan
            text={error}
            className="text-sm lg:text-sm text-infrared-burn font-medium leading-4 tracking-[0.24px] px-16"
          />
        ) : null}
      </div>
    );
  },
);

export default TextInput;
